import { AddCircle } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { createContext, useEffect, useState } from 'react'
import { ModalAgregaDepartamentoComponent } from '../../components/departamentos/ModalAgregaDepartamentoComponent';
import { ModalEliminarDepartamentoComponent } from '../../components/departamentos/ModalEliminarDepartamentoComponent';
import { TablaDepartamentos } from '../../components/departamentos/TablaDepartamentos';
import { TituloComponent } from '../../components/TituloComponent';
import { ObtenerDepartamentos } from '../../helpers/DepartamentosHelper';

export const DepartamentosContext = createContext();

export const DepartamentosPage = () => {
    const [modalAgregaDepartamento, setModalAgregaDepartamento] = useState(false);
    const [modalEliminarDepartamento, setModalEliminarDepartamento] = useState(false)
    const [departamentoSel, setDepartamentoSel] = useState();
    const [departamentos, setDepartamentos] = useState();

    const obtenerDepartamentos = () => {
        ObtenerDepartamentos().then(response => {
            console.log('departamentos desde api', response)
            setDepartamentos(response);
        })
    }

    useEffect(() => {
        obtenerDepartamentos();
    }, [])
    

  return (
    <DepartamentosContext.Provider value={{modalAgregaDepartamento, setModalAgregaDepartamento, departamentoSel, setDepartamentoSel, obtenerDepartamentos,
        modalEliminarDepartamento, setModalEliminarDepartamento, departamentos}} >
    <div
    style={{
        marginTop:10,
        marginLeft:40
    }}
>         
    <span
    style={{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        maxWidth:'40%'
      }}
  >
      <TituloComponent titulo='Departamentos' />
    <IconButton
      onClick={() => {setDepartamentoSel(); setModalAgregaDepartamento(true)}}
    >
      <AddCircle style={{color:'#60318A'}} color="#60318A" />
      Agregar
    </IconButton>
  </span>
  <div
      style={{
      fontSize:28,
      fontWeight:'regular',
      marginLeft:10,
      maxWidth:900,
      flex:1,
      backgroundColor:'transparent'
      }}
  >
      <TablaDepartamentos departamentos={departamentos} />
  </div>
  </div>
  <ModalAgregaDepartamentoComponent />
  <ModalEliminarDepartamentoComponent /> 
</DepartamentosContext.Provider>
  )
}
